import { IRideRoute } from "../../models";

interface IRouteColorMap {
  [id: number]: string;
}

export interface IRouteColorObject {
  colorId: number;
  colorValue: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export const routeColorsByIdMapping: IRouteColorMap = {
  "1": "#059A8F", // provided by PRD
  "2": "#842EF3", // provided by PRD
  "3": "#D0021B", // provided by PRD
  "4": "#69A2E4", // provided by PRD
  "5": "#FF8A80", // provided by PRD
  "6": "#C16A03", // provided by PRD
  "7": "#3F51B5", // provided by PRD
  "8": "#FF9900", // provided by PRD
  "9": "#C781FE", // provided by PRD
  "10": "#BFB12F", // provided by PRD
  "11": "#4B0082", // Indigo
  "12": "#2F4F4F", // DarkSlateGray
  "13": "#800000", // Maroon
  "14": "#483D8B", // DarkSlateBlue
  "15": "#008080", // Teal
  "16": "#8B4513", // SaddleBrown
  "17": "#556B2F", // DarkOliveGreen
  "18": "#9400D3", // DarkViolet
  "19": "#A52A2A", // Brown
  "20": "#4682B4", // SteelBlue
  "21": "#32CD32", // LimeGreen
  "22": "#800080", // Purple
  "23": "#8B0000", // DarkRed
  "24": "#006400", // DarkGreen
  "25": "#4169E1", // RoyalBlue
  "26": "#228B22", // ForestGreen
  "27": "#D2691E", // Chocolate
  "28": "#FF4500", // OrangeRed
  "29": "#9932CC", // DarkOrchid
  "30": "#FFD700", // Gold
  "31": "#CD5C5C", // IndianRed
  "32": "#FF6347", // Tomato
  "33": "#E9967A", // DarkSalmon
  "34": "#BA55D3", // MediumOrchid
  "35": "#FF1493", // DeepPink
  "36": "#20B2AA", // LightSeaGreen
  "37": "#00CED1", // DarkTurquoise
  "38": "#6A5ACD", // SlateBlue
  "39": "#FF69B4", // HotPink
  "40": "#FFDAB9", // PeachPuff
  "41": "#DAA520", // GoldenRod
  "42": "#8A2BE2", // BlueViolet
  "43": "#8B008B", // DarkMagenta
  "44": "#B22222", // FireBrick
  "45": "#5F9EA0", // CadetBlue
  "46": "#1E90FF", // DodgerBlue
  "47": "#A0522D", // Sienna
  "48": "#00FA9A", // MediumSpringGreen
  "49": "#7FFF00", // Chartreuse
  "50": "#7B68EE", // MediumSlateBlue
} as const;
/* eslint-enable @typescript-eslint/naming-convention */

export const MAX_COLOR_INDEX =
  Object.keys(routeColorsByIdMapping).length -
  1; /* last element used for alt color only */

export const routeColorsIds = (): number[] => {
  return Object.keys(routeColorsByIdMapping).map(Number);
};

export const resolveAlternateColor = (
  colorId: number,
  alt?: boolean,
): number => {
  return alt ? colorId + 1 : colorId;
};

export const DEFAULT_ROUTE_COLOR_OBJECT: IRouteColorObject = {
  colorId: 1,
  colorValue: routeColorsByIdMapping[1],
};

export const DEFAULT_ROUTE_COLOR_OBJECT_STATION_ROUTE: IRouteColorObject = {
  colorId: 2,
  colorValue: routeColorsByIdMapping[2],
};

export const DEFAULT_ROUTE_COLOR_OBJECT_COURSE: IRouteColorObject = {
  colorId: 3,
  colorValue: routeColorsByIdMapping[3],
};

export const getDefaultColorObject = ({
  stationRouteId,
  courseId,
}: {
  stationRouteId?: number;
  courseId?: number;
}): IRouteColorObject => {
  if (stationRouteId) {
    return DEFAULT_ROUTE_COLOR_OBJECT_STATION_ROUTE;
  }

  if (courseId) {
    return DEFAULT_ROUTE_COLOR_OBJECT_COURSE;
  }

  return DEFAULT_ROUTE_COLOR_OBJECT;
};

export const isTrackingRoute = (route: IRideRoute): boolean =>
  Boolean(route.isTrackingRoute ?? route.carTrackingInfo);
